
import React from 'react';

interface LoaderProps {
  fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ fullScreen }) => {
  const content = (
    <div className="flex flex-col items-center gap-6">
      <div className="relative w-20 h-20 flex items-center justify-center">
        {/* Outer Glow Ring */}
        <div className="absolute inset-0 border-2 border-brand-primary/5 rounded-full"></div>
        
        {/* Spinning Rings */}
        <div className="absolute inset-0 border-b-2 border-brand-primary rounded-full animate-spin-slow"></div>
        <div className="absolute inset-2 border-t-2 border-brand-primary/40 rounded-full animate-spin"></div>
        
        {/* Center Hexagon */}
        <svg width="24" height="24" viewBox="0 0 100 100" className="text-brand-primary animate-pulse-slow">
           <path d="M50 5L93.3 30V80L50 105L6.7 80V30L50 5Z" fill="currentColor" opacity="0.1" />
           <path d="M50 5L93.3 30V80L50 105L6.7 80V30L50 5Z" stroke="currentColor" strokeWidth="4" fill="none" />
        </svg>
      </div>
      <div className="text-center space-y-1">
        <p className="text-brand-primary font-black text-[10px] animate-pulse tracking-[0.4em] uppercase">Initializing Nexus</p>
        <p className="text-brand-muted font-bold text-[8px] uppercase tracking-[0.2em] opacity-50">Secure Sync in Progress</p>
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-brand-dark flex items-center justify-center z-[999] backdrop-blur-3xl">
        <div className="absolute inset-0 bg-brand-primary/5 opacity-20 pointer-events-none"></div>
        {content}
      </div>
    );
  }

  return content;
};

export default Loader;
